import React from "react";
import "./AboutUs.css";
import Slideshow from "./Slideshow";

const AboutUs = ({ isMenuOpen }) => {
  return (
    <div className="about-us" id="about">
      {/* Conditionally render the secondary header only when the menu is closed */}
      {!isMenuOpen && (
        <div className="about-us-secondary-header">
          <p>
            A South African based fine mineral processing research & technology
            development company. O.D.E.M. of komodo® vertically stirred mills.
          </p>
        </div>
      )}

      {/* Main Header */}
      <div className="about-us-header">
        <p>Featured Product</p>
      </div>

      {/* Content Container with Two Columns */}
      <div className="about-us-content">
        {/* Left Column */}
        <div className="content-section left-section">
          <div className="logo-section">
            <img
              src={`${process.env.PUBLIC_URL}/Images/Komodo_Logo.svg`}
              alt="Komodo Logo"
            />
          </div>
          <p>
            <span className="vsm-title">VSM</span>
            <span className="Tm">™</span>
          </p>

          <p>more than a mill...</p>
          <p>
            <span className="compsolution">
              A COMPREHENSIVE SOLUTION OFFERING <br /> TOWARDS OPTIMIZATION OF
              FINE MILLING <br /> IN MODERN METALLURGICAL PROCESS <br /> FLOW
              CIRCUITS
            </span>
          </p>
        </div>

        {/* Right Column */}
        <div className="content-section right-section">
          <div className="right-section-content-wrapper">
            <p className="right-section-content">
              UNLOCKING <span className="value">VALUE</span> THROUGH <br />
              <span className="energy">ENERGY EFFICIENT</span> <br />
              <span className="fine">FINE PARTICLE</span> <br />
              <span className="communication">COMMINUTION</span>
            </p>
          </div>

          {/* Quote Card */}
          {/* <div className="quote-card">
            <blockquote>
              <span className="quote-symbol">“</span>
              <blockquote>
                Our commitment to innovation drives energy efficiency and
                excellence in fine particle comminution.
              </blockquote>
              <span className="quote-symbol-close">”</span>
            </blockquote>
            <p className="quote-author">- komodo®</p>
          </div> */}
        </div>
      </div>

      {/* Slideshow Component */}
      <Slideshow />
    </div>
  );
};

export default AboutUs;
